import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { Article, Product } from 'src/typings';
import { ProductService } from '../product.service';

@Component({
  selector: 'app-add-article',
  templateUrl: './add-article.component.html',
  styleUrls: ['./add-article.component.scss']
})
export class AddArticleComponent {
  @Input() product: Product | undefined;

  @Input() dialogRef: MatDialogRef<AddArticleComponent> | undefined;

  @Output() doneEvent: EventEmitter<Article> = new EventEmitter();

  loading: boolean = false;

  formGroup: UntypedFormGroup = this.fb.group({
    article: new UntypedFormControl()
  });

  constructor(private fb: UntypedFormBuilder, private productService: ProductService) {}

  async create() {
    if (!this.product) return window.alert('Не выбран продукт!');
    this.loading = true;
    try {
      const res = await firstValueFrom(
        this.productService.addAlternativeArticle({
          article: this.formGroup.value.article,
          product_id: this.product.id
        })
      );
      this.dialogRef?.close();
      this.doneEvent.emit(res);
    } catch (err) {
      console.error(err);
    }
    this.loading = false;
    return;
  }
}
